import { SelectionModel } from '@angular/cdk/collections';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'checkboxLabel',
  standalone: true,
})
export class CheckboxLabelPipe implements PipeTransform {
  private _translocoService = inject(TranslocoService);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(selectionLength: number, selection: SelectionModel<any>, row?: any, index?: number, totalRows?: number): string {
    const select = this.translate('select');
    const deselect = this.translate('deselect');
    const all = this.translate('all');
    const rowTranslate = this.translate('row');

    if (!row) {
      return `${selection.hasValue() && selectionLength === totalRows ? deselect : select} ${all}`;
    }

    return `${selection.isSelected(row) ? deselect : select} ${rowTranslate} ${(index ?? 0) + 1}`;
  }

  private translate(text: string) {
    return this._translocoService.translate(text);
  }
}
